/** Mirrors the backend's `<SLUG>_<KEY>` convention
 *  (`apps/backend/libs/tenant/src/config-loading/offline-env-mapper.ts:20`). Exported as a `const`
 *  array so the env surface stays greppable despite the dynamic key lookup below (R10). */
export const REQUIRED_TENANT_ENV_KEYS = [
  'COGNITO_USER_POOL_ID',
  'COGNITO_USER_POOL_WEB_ID',
  'GOOGLE_TAG_MANAGER_KEY',
  'FACEBOOK_TRACK_ID',
  'GOOGLE_RECAPTCHA_KEY',
] as const;

export type TenantEnvKey = (typeof REQUIRED_TENANT_ENV_KEYS)[number];

/** `process.env.REACT_APP_<SLUG>_<KEY>`. Dynamic access is safe here (D7 consequence 1, verified
 *  against `apps/web-client/config/env.js:94-99`): CRA's `DefinePlugin` substitutes the whole
 *  `process.env` object, not per-key member expressions. */
export const readTenantEnv = (slug: string, key: TenantEnvKey): string | undefined =>
  process.env[`REACT_APP_${slug.toUpperCase()}_${key}`];
